/**
 * Legal and branding strings for OAuth verification and public pages.
 * Keep OAUTH_APP_NAME identical to the Google Cloud OAuth consent screen app name.
 */
export const OAUTH_APP_NAME = "HireAera";

/** Operator / developer name shown for trust and contact. */
export const SITE_OPERATOR = "HireAera";

export const DEFAULT_SUPPORT_EMAIL = "support@hireaera.com";

export function getSupportEmail(): string {
  const v = process.env.NEXT_PUBLIC_SUPPORT_EMAIL;
  if (typeof v === "string" && v.trim().length > 0) return v.trim();
  return DEFAULT_SUPPORT_EMAIL;
}
